"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GridHead = _interopRequireDefault(require("./GridHead"));

var _GridBody = _interopRequireDefault(require("./GridBody"));

var _gridConfig = require("./gridConfig");

var _ResizeObserver = _interopRequireDefault(require("./ResizeObserver"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GridTable = /*#__PURE__*/function (_React$Component) {
  _inherits(GridTable, _React$Component);

  var _super = _createSuper(GridTable);

  function GridTable() {
    var _this;

    _classCallCheck(this, GridTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      // Resize columns:
      resizedColumnName: null,
      resizeStartX: null,
      defaultCellWidth: null,
      forceWidth: null,
      // Fixed header:
      fixedWidths: {}
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      }

      if (!Element.prototype.closest) {
        Element.prototype.closest = function (s) {
          var el = this;
          if (!document.documentElement.contains(el)) return null;

          do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
          } while (el !== null && el.nodeType === 1);

          return null;
        };
      }

      _this.restartHeaderResizeObserver();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.removeHeaderResizeObserver();

      document.removeEventListener('mousemove', _this.handleMoveResize);
      document.removeEventListener('mouseup', _this.handleFinishResize);
      document.removeEventListener('mouseleave', _this.handleFinishResize);
    });

    _defineProperty(_assertThisInitialized(_this), "handleHeaderResize", function (entries) {
      var fixedWidths = {};
      entries.forEach(function (entry) {
        var columnName = entry.target.dataset.name;
        var newWidth = parseInt(getComputedStyle(entry.target).width, 10);
        fixedWidths[columnName] = newWidth;
      });

      _this.setState({
        fixedWidths: _objectSpread(_objectSpread({}, _this.state.fixedWidths), fixedWidths)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "restartHeaderResizeObserver", function () {
      _this.removeHeaderResizeObserver();

      _this.addHeaderResizeObserver();

      _this.resizeObserver.fireAll && _this.resizeObserver.fireAll(); // if polyfill
    });

    _defineProperty(_assertThisInitialized(_this), "removeHeaderResizeObserver", function () {
      _this.resizeObserver.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "addHeaderResizeObserver", function () {
      if (!_this.gridBody) return;

      var firstRowCells = _this.gridBody.querySelectorAll('tbody tr:nth-child(1) td');

      Array.from(firstRowCells).forEach(function (cell) {
        return _this.resizeObserver.observe(cell);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "resizeObserver", new _ResizeObserver["default"](_this.handleHeaderResize));

    _defineProperty(_assertThisInitialized(_this), "saveGridBodyRef", function (ref) {
      return _this.gridBody = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "handleStartResize", function (event) {
      var noResize = _this.props.params.options.noResize;
      if (noResize) return;
      event.persist();
      var column = event.currentTarget.closest('th');
      var columnName = column.dataset.name;

      _this.setState(function () {
        return {
          resizedColumnName: columnName,
          resizeStartX: event.pageX,
          defaultCellWidth: column.offsetWidth
        };
      }, function () {
        document.addEventListener('mousemove', _this.handleMoveResize);
        document.addEventListener('mouseup', _this.handleFinishResize);
        document.addEventListener('mouseleave', _this.handleFinishResize);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMoveResize", function (event) {
      _this.setState(function (prevState) {
        var resizeStartX = prevState.resizeStartX,
            defaultCellWidth = prevState.defaultCellWidth;
        if (!defaultCellWidth) return;
        var newWidth = defaultCellWidth + event.pageX - resizeStartX;
        return {
          forceWidth: newWidth <= _gridConfig.MINIMUM_RESIZE_CELL_WIDTH ? _gridConfig.MINIMUM_RESIZE_CELL_WIDTH : newWidth
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFinishResize", function (event) {
      var _this$props$params = _this.props.params,
          onChangeFields = _this$props$params.onChangeFields,
          fields = _this$props$params.fields;
      var _this$state = _this.state,
          forceWidth = _this$state.forceWidth,
          resizedColumnName = _this$state.resizedColumnName; // if there was a drag, not a click.

      if (forceWidth) {
        onChangeFields(_objectSpread(_objectSpread({}, fields), {}, _defineProperty({}, resizedColumnName, _objectSpread(_objectSpread({}, fields[resizedColumnName]), {}, {
          width: forceWidth
        }))));
      }

      _this.setState(function () {
        return {
          resizedColumnName: null,
          resizeStartX: null,
          defaultCellWidth: null,
          forceWidth: null
        };
      }, function () {
        return _this.removeListeners();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeListeners", function () {
      document.removeEventListener('mousemove', _this.handleMoveResize);
      document.removeEventListener('mouseup', _this.handleFinishResize);
      document.removeEventListener('mouseleave', _this.handleFinishResize);
    });

    _defineProperty(_assertThisInitialized(_this), "getFirstField", function (fields) {
      return Object.keys(fields).find(function (field) {
        return !fields[field].hidden;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getLastField", function (fields) {
      return Object.keys(fields).reduce(function (last, field) {
        return !fields[field].hidden ? field : last;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$state2 = _this.state,
          resizedColumnName = _this$state2.resizedColumnName,
          forceWidth = _this$state2.forceWidth,
          fixedWidths = _this$state2.fixedWidths;
      var _this$props = _this.props,
          params = _this$props.params,
          data = _this$props.data,
          groups = _this$props.groups,
          sort = _this$props.sort,
          selected = _this$props.selected,
          selectItem = _this$props.selectItem,
          multiSelected = _this$props.multiSelected,
          toggleRowVisibility = _this$props.toggleRowVisibility,
          columnsMenu = _this$props.columnsMenu,
          gridId = _this$props.gridId;

      var lastField = _this.getLastField(params.fields);

      var firstField = _this.getFirstField(params.fields);

      var commonParams = {
        data: data,
        params: params,
        groups: groups,
        resizedColumnName: resizedColumnName,
        lastField: lastField,
        forceWidth: forceWidth,
        fixedWidths: fixedWidths
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "table-grid-wrap"
      }, /*#__PURE__*/_react["default"].createElement(_GridHead["default"], _extends({}, commonParams, {
        sort: sort,
        handleStartResize: _this.handleStartResize,
        columnsMenu: columnsMenu,
        gridId: gridId
      })), /*#__PURE__*/_react["default"].createElement(_GridBody["default"], _extends({}, commonParams, {
        saveGridBodyRef: _this.saveGridBodyRef,
        selected: selected,
        selectItem: selectItem,
        multiSelected: multiSelected,
        toggleRowVisibility: toggleRowVisibility,
        firstField: firstField
      })));
    });

    return _this;
  }

  _createClass(GridTable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevParams = _ref.params,
          prevData = _ref.data;
      var _this$props2 = this.props,
          params = _this$props2.params,
          data = _this$props2.data;
      var isDataLoaded = data.length && prevParams.loading && !params.loading;
      var isDataChanged = prevData !== data;
      var isGridFieldsChanged = prevParams.fields !== params.fields;

      if (isGridFieldsChanged || isDataChanged || isDataLoaded) {
        this.restartHeaderResizeObserver();
      }
    }
  }]);

  return GridTable;
}(_react["default"].Component);

exports["default"] = GridTable;
GridTable.propTypes = {
  data: _propTypes["default"].array,
  params: _propTypes["default"].object.isRequired,
  groups: _propTypes["default"].object,
  selectItem: _propTypes["default"].func,
  toggleRowVisibility: _propTypes["default"].func,
  selected: _propTypes["default"].object,
  sort: _propTypes["default"].object,
  multiSelected: _propTypes["default"].array,
  columnsMenu: _propTypes["default"].object,
  gridId: _propTypes["default"].number
};